import script from "./AsignacionRolesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AsignacionRolesView.vue?vue&type=script&lang=ts&setup=true"

import "./AsignacionRolesView.vue?vue&type=style&index=0&id=012c1fd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012c1fd0"]])

export default __exports__